<template>
  <div>
    <b-modal no-close-on-backdrop id="save-modal" hide-header hide-footer>
      <div class="method-save" v-if="step === 1">
        <p class="my-4 text-center">
          Do you want to save this method for future use?
        </p>
        <div class="method-save__action-btns">
          <button @click="proceedToNext">Yes</button>
          <button @click="closeModal">No</button>
        </div>
      </div>
      <div v-else-if="step === 2">
        <Form @submit="save">
          <label>{{ $t('enter-email-to-continue') }}</label>
          <text-input
            id="field2"
            name="email"
            v-model:value.trim="email"
            :disabled="loading"
            :placeholder="$t('sign-up.email')"
            autocomplete="email"
          />
          <CustomButton
            type="submit"
            :disabled="loading"
            :loader="loading"
            className="button-default w-100 mt-5"
            name="CONTINUE"
          />
        </Form>
      </div>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable */
import { Magic } from "magic-sdk";
import { Form } from "vee-validate";
import CustomButton from "../views/customButton.vue";
import { PASSWORD_LESS_SIGNIN } from "@/store/modules/auth/consts.js";
import { GET_USER_INFO } from "@/store/modules/user/consts.js";
import { mapGetters } from "vuex";
const apiKey = process.env.VUE_APP_MAGIC_PUBLISHABLE_KEY;
const magic = new Magic(apiKey);

export default {
  name: "magiclogin",
  components: {
    CustomButton,
    Form,
  },
  data() {
    return {
      email: "",
      step: 1,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "user/userInfo",
    }),
  },
  watch: {
    userInfo: {
      handler(val) {
        if (!this.email) {
          this.email = val.email;
        }
      },
    },
  },
  mounted() {
    // adding event handlers to root
    this.step = 1;
    window.EventBus.on("showModal", () => {
      this.showModal();
    });
    window.EventBus.on("closeModal", () => {
      this.closeModal();
    });
  },
  methods: {
    proceedToNext() {
      this.step += 1;
    },
    async save() {
      try {
        this.loading = true;
        const res = await magic.auth.loginWithEmailOTP({ email: this.email });
        let encData = {
          email: this.email,
        };
        if (this.email.toLowerCase() != this.userInfo.email.toLowerCase()) {
          encData.tempEmail = this.userInfo.email;
        }
        const data = {
          headers: {
            Authorization: `Bearer ${res}`,
          },
          data: {
            encryptedReq: this.encryptStringWithRSA(JSON.stringify(encData)),
          },
        };
        await this.$store.dispatch(`auth/${PASSWORD_LESS_SIGNIN}`, data);
        this.$store.dispatch(`user/${GET_USER_INFO}`);
        magic.user.logout();
        this.loading = false;
        this.closeModal();
      } catch (err) {
        this.loading = false;
      }
    },
    showModal() {
      if (this.userInfo.ssoStatus && !this.userInfo.verified) {
        this.$bvModal.show(`save-modal`);
      }
    },
    closeModal() {
      this.$bvModal.hide(`save-modal`);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep(#save-modal) {
  margin-top: 50% !important;
}

.method-save {
  &__action-btns {
    display: flex;
    justify-content: center;

    button {
      border-radius: 5px;
      padding: 0px 10px;
      cursor: pointer;
      margin: 0px 5px;
    }

    :nth-child(1) {
      border: 1px solid #5559fe;
    }

    :nth-child(2) {
      background: #5559fe;
      color: white;
    }
  }
}

.enter-email {
  button {
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
    margin: 0px 5px;
    background: #5559fe;
    color: white;
  }
}

.enter-otp {
  button {
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
    margin: 0px 5px;
    background: #5559fe;
    color: white;
  }
}
</style>
